/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type CreateFineThresholdSettings = {
    ownerType: CreateFineThresholdSettings.ownerType;
    ownerId: string;
    deviceType: CreateFineThresholdSettings.deviceType;
    overdueDays: number;
    type: CreateFineThresholdSettings.type;
    fineAmount: number;
};
export namespace CreateFineThresholdSettings {
    export enum ownerType {
        SHOP = 'SHOP',
        FINANCIER = 'FINANCIER',
    }
    export enum deviceType {
        IOS = 'IOS',
        ANDROID = 'ANDROID',
    }
    export enum type {
        PER_DIEM = 'PER_DIEM',
        FLAT_RATE = 'FLAT_RATE',
    }
}

